import axios from 'axios';

export const fetchRegionalAlerts = () => {
  const endpoint = '/api/v1/RegionalAlerts/All';
  return axios
    .create({ withCredentials: true })
    .get(endpoint, {
      headers: {
        'WS-Orig-Path': window.location.href,
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
